import { useState } from 'react';
import { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import EstablishmentTable from './EstablishmentTable';
import EstablishmentTypeTable from './EstablishmentTypeTable';

const EstablishmentManagement = () => {
  const { t } = useTranslation(['administration']);
  const [activeTab, setActiveTab] = useState('establishments');
  const [activeKey, setActiveKey] = useState(0);

  const items: TabsProps['items'] = [
    {
      key: 'establishments',
      label: t('listOfEstablishments', 'Establishments'),
      children: <EstablishmentTable />,
    },
    {
      key: 'establishmentTypes',
      label: t('typesOfEstablishments', 'Establishment Types'),
      children: <EstablishmentTypeTable />,
    },
  ];

  return (
    <>
      <section className="mb-16 mt-12 w-full">
        <h5 className="text-[24px] text-headings-font-color sm:text-[36px]">
          {t('establishmentManagement')}
        </h5>
      </section>

      <section className="mb-6 mt-16 grid w-fit grid-cols-2 rounded-lg bg-card-bg-color p-2">
        {items.map((item, index: number) => (
          <span
            key={index + item.key}
            className={classNames(
              'cursor-pointer px-3 py-2 text-center transition-colors duration-300 ease-in-out',
              { 'rounded-md bg-white text-primary': activeTab === item.key }
            )}
            onClick={() => {
              setActiveTab(item.key);
              setActiveKey(index);
            }}
          >
            {item.label}
          </span>
        ))}
      </section>

      {items[activeKey].children}
    </>
  );
};

export default EstablishmentManagement;
